import { createContext, PropsWithChildren, useMemo } from 'react'
import { SwitchTransition, Transition } from 'react-transition-group'
import { useRouter } from 'next/router'

import { useTransition } from './use-transition'

export const TransitionContext = createContext<undefined>(undefined)

const TransitionProvider = ({ children }: PropsWithChildren) => {
  const router = useRouter()
  const contextValue = useMemo(() => undefined, [])
  const { nodeRef, handleTransitionEnter, handleTransitionLeave, handleEndListener } =
    useTransition()

  return (
    <TransitionContext.Provider value={contextValue}>
      <SwitchTransition mode="out-in">
        <Transition
          nodeRef={nodeRef}
          key={router.pathname}
          onExit={handleTransitionLeave}
          onEnter={handleTransitionEnter}
          addEndListener={handleEndListener}
          appear
          unmountOnExit
        >
          <main ref={nodeRef} className="static" style={{ opacity: 0 }}>
            {children}
          </main>
        </Transition>
      </SwitchTransition>
    </TransitionContext.Provider>
  )
}

export default TransitionProvider
